<template>
  <div class="tests-page">
    <router-view />
    <vfooter type="landing" :company_language="company_language" />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import vfooter from '@/routes_new/outer/components/vfooter';

  export default {
    name: 'InterviewTests',

    components: {
      vfooter
    },

    computed: {
      ...mapGetters('interview', ['company_language'])
    }
  };
</script>

<style scoped lang="scss">
  .tests-page {
    -webkit-user-select: none;
    user-select: none;
    flex: 1;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    background-color: #e5e5e5;
    overflow: hidden;
  }
</style>
